import { Application } from "@hotwired/stimulus";

const application = Application.start();

// Configure Stimulus development experience
application.debug = false;
window.Stimulus = application;

import jquery from "jquery";
window.jQuery = jquery;
window.$ = jquery;

import Cocooned from "@notus.sh/cocooned";
Cocooned.start();

import "sharer.js";

document.addEventListener("turbo:load", function () {
  Sharer.init();
});

export { application };
